<template>

  <header class="header" :class="$route.path === '/broadcast' && 'no-white-banner'">
	  <div class="grid-container c2">
			<aside :style="$route.path !== '/broadcast' ? null : 'visibility: hidden'" id="menu-toggle" :class="open ? 'active' : ''" @click="handleClick">{{ open ? 'Close' : 'Menu' }}</aside>
			<aside v-if="stream == 'on'" id="livestream-toggle" :class="stream_open ? 'active' : ''" @click="streamClick"></aside>
			
			<div class="logo">
	      <div class="link" to="/" @click="homeClick">
	          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1594 322" class="logo-svg">
	              <g id="Layer_2" data-name="Layer 2">
	                  <g id="Layer_1-2" data-name="Layer 1">
	                      <rect class="logo-bg" width="1594" height="322"></rect>
	                      <path class="logo-fg" d="M61.55,258.24,92.24,63.76h77.38q32.74,0,49.26,15.87t11.35,48.1q-10.32,66-79.18,66H122.42L112.1,258.24Zm74.8-153.72L128.87,153h8.51c4.81,0,8.47,0,11-.12a57.2,57.2,0,0,0,9.67-1.42,24.88,24.88,0,0,0,9.16-3.61,25.09,25.09,0,0,0,6.19-7,29.46,29.46,0,0,0,4-11.6,30.49,30.49,0,0,0-.26-12,17.79,17.79,0,0,0-3.61-7.35q-2.33-2.57-7.74-3.74a68,68,0,0,0-9.41-1.42q-4-.26-11.48-.25Zm230.32,2.06h-60.1l-5.15,32.5h57l-6.71,42.81h-57l-5.42,33.53h60.1l-6.71,42.82H232L262.73,63.76H373.37Zm120.44,72,48.49,79.7H472.67l-35.85-74.8h-.52l-11.86,74.8H373.89L404.58,63.76h75.57q30.44,0,46.68,15t11.61,44.88a69.3,69.3,0,0,1-17,36.11A58.31,58.31,0,0,1,487.11,178.54ZM449.2,102.45l-7.74,48.49h4.9q35.07,0,38.95-24.24c.86-5,.55-9.2-.9-12.64a14,14,0,0,0-7.36-7.48,43.36,43.36,0,0,0-10.44-3.23,75.68,75.68,0,0,0-12.51-.9Zm235.74,4.13H623.81l-5.16,32.5H674.1l-6.7,42.81H611.94l-12.12,76.35H549.27L580,63.76H691.64Zm133.6-49.26a102.62,102.62,0,0,1,39.2,7.48A93.72,93.72,0,0,1,889,85.17,76.69,76.69,0,0,1,907.78,117a88,88,0,0,1,2.57,40.37q-7.47,47.21-42.55,77.25t-82,30q-46.95,0-72.48-30.17t-18-77.12a106,106,0,0,1,23.34-51.84A129.53,129.53,0,0,1,764,69.83,126.13,126.13,0,0,1,818.54,57.32ZM847,121.8q-13.8-15.48-36.24-15.48T769.66,121.8q-18.7,15.47-21.79,35.85-4.14,24.75,9.28,41.39t36.37,16.64q23,0,41.52-16.64a69.32,69.32,0,0,0,22.7-41.39Q860.83,137.28,847,121.8Zm184,56.74,48.49,79.7h-62.93l-35.85-74.8h-.52l-11.87,74.8H917.83l30.7-194.48h75.57q30.42,0,46.68,15t11.61,44.88a69.32,69.32,0,0,1-17,36.11A58.28,58.28,0,0,1,1031.06,178.54Zm-37.91-76.09-7.74,48.49h4.9q35.07,0,38.94-24.24,1.29-7.49-.9-12.64a13.91,13.91,0,0,0-7.35-7.48,43.29,43.29,0,0,0-10.45-3.23,75.47,75.47,0,0,0-12.5-.9Zm88.46,155.79,63.71-194.48h49.77l23.22,104,58-104h50.29l-1.29,194.48h-50.55l3.61-111.94h-.51l-64.48,111.94h-20.12L1166.46,146.3H1166l-34,111.94Zm389.71-33.79h-69.64l-18.82,33.79h-53.65L1434.7,63.76h55.19l42.56,194.48h-53.91Zm-7.48-38.69L1453,123.86h-.52l-30.69,61.9Z"></path>
	                  </g>
	              </g>
	          </svg>
	          <h1>Performa</h1>
	      </div>
	  </div>
			    
	  </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data () {
	  return {
		  stream: ''
	  };
  },
  computed: {
    open () {
      return this.$store.state.navOpen
    },
    stream_open () {
	    return this.$store.state.streamOpen
    }
  },
  methods: {
	  getContent () {
		  this.$prismic.client.getSingle('homepage')
		  	.then((document) => {
			  	this.stream = document.data.livestream
		  	})
	  },
    handleClick () {
      this.$store.dispatch('toggleNav'),      
	    this.$store.state.schedOpen = false,
	    this.$store.state.streamOpen = false
    },
    homeClick () {
	    this.$router.push('/'),
	    this.$store.state.navOpen = false,
	    this.$store.state.schedOpen = false,
	    console.log('fired')
    },
    streamClick () {
      this.$store.dispatch('toggleStream'),      
	    this.$store.state.navOpen = false,
	    this.$store.state.schedOpen = false
    }
  },
  created () {
	  this.getContent();
  },
  mounted () {
  }
}
</script>

<style>
	.no-white-banner {
		background-color: transparent !important;
	}
</style>